export default {
  addAvailabilityDialog(state) {
    return state.addAvailabilityDialog;
  },
};
